<template>
  <dashboard>
    <template v-slot:content>
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2 mb-1">
              <b-col lg="8" md="7">
                <b-row class="mt-2">
                  <b-col lg="8" md="6">
                    <h5>Return</h5>
                  </b-col>
                </b-row>
              </b-col>
              <b-col lg="4" md="5">
                <div class="align-items-center text-right">
                  <!-- <font-awesome-icon
                    :icon="['far', 'question-circle']"
                    size="2x"
                    id="help-tooltip"
                  />-->
                  <!-- <b-tooltip target="help-tooltip" placement="left">Help Tooltip !</b-tooltip> -->
                  <b-col lg="8" class="float-right p-0">
                    <router-link v-bind:to="'../invoices-history'">
                      <b-button
                        @click="$router.push('invoices-history')"
                        id="back-invoice-history"
                        >Back to Invoice History</b-button
                      >
                    </router-link>
                  </b-col>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section class="checkout">
        <b-container fluid>
          <b-row>
            <b-col lg="8" md="7" class="pr-0 fadein">
              <div class="table-dark-bg box-shadow p-3 pb-0">
                <return-done />
              </div>
            </b-col>
            <b-col lg="4" md="5" class="fadein">
              <return-order-summary />
            </b-col>
          </b-row>
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import Dashboard from "../views/Dashboard";
import ToggleBtn from "../components/ToggleButton";
import PaymentMethods from "../components/PaymentMethods";
import ReturnOrderSummary from "../components/ReturnOrderSummary";
import ReturnDone from "../components/ReturnDone";
import CustomerInfoCheckout from "../components/CustomerInfoCheckout";
import { BTooltip } from "bootstrap-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { mapState } from "vuex";

//import { mapState } from 'vuex'

library.add(faQuestionCircle, faPen);

export default {
  name: "return-succesfull",
  components: {
    Dashboard,
    ToggleBtn,
    BTooltip,
    PaymentMethods,
    ReturnOrderSummary,
    ReturnDone,
    CustomerInfoCheckout,
  },
  data() {
    return {
      Title: "Return",
      payAmt: 0,
      splitPayment: false,
    };
  },
  // watch: {
  //   payAmt() {
  //     if (this.invoice.data == "") {
  //       if (this.payAmt > this.state.billing.order.data.total) {
  //         alert("Enter amount is grater then bill amount");
  //       }
  //     }
  //   }
  // },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
  },
  mounted() {},
  methods: {},
};
</script>
